/** Countries Fablelot launches in (owner decision 2026-10-24): USA, Canada,
 * Mexico, Europe, Australia and all of Southeast Asia. Russia and Belarus are
 * left out because of sanctions. Edit this one list to add or remove a country. */
export const launchRegions = {
  northAmerica: ['US', 'CA', 'MX'],
  europe: [
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE',
    'GB', 'NO', 'IS', 'LI', 'CH', 'AD', 'MC', 'SM', 'VA',
    'AL', 'BA', 'ME', 'MK', 'RS', 'XK', 'MD', 'UA',
  ],
  oceania: ['AU'],
  southeastAsia: ['BN', 'KH', 'ID', 'LA', 'MY', 'MM', 'PH', 'SG', 'TH', 'TL', 'VN'],
} as const;
export const launchCountries: readonly string[] = Object.freeze(Object.values(launchRegions).flat());
const set = new Set(launchCountries);
export const isLaunchCountry = (code: unknown): code is string => typeof code === 'string' && set.has(code);
/** Delivery addresses Fablelot can't serve because of US/EU/UK sanctions:
 * Crimea, Sevastopol and the Donetsk and Luhansk regions of Ukraine
 * (by postal code range or region name). */
export function sanctionedAddress(a: { country?: string; region?: string; city?: string; postalCode?: string }): boolean {
  if (a.country !== 'UA') return false;
  const zip = Number(String(a.postalCode ?? '').replace(/\s/g, '').slice(0, 5));
  if (Number.isInteger(zip) && ((zip >= 83000 && zip <= 87999) || (zip >= 91000 && zip <= 99999))) return true;
  const text = ((a.region ?? '') + ' ' + (a.city ?? '')).toLowerCase();
  return /crimea|krym|крим|крым|sevastopol|севастопол|donetsk|донецьк|донецк|luhansk|lugansk|луганськ|луганск/.test(text);
}
/** A country's name in the viewer's language (falls back to the code). */
export function countryName(code: string, locale = 'en'): string {
  if (code === 'XK') return 'Kosovo';
  try { return new Intl.DisplayNames([locale, 'en'], { type: 'region' }).of(code) ?? code; } catch { return code; }
}
/** Country choices sorted by their name in the viewer's language. */
export function launchCountryOptions(locale = 'en'): { code: string; name: string }[] {
  return launchCountries.map(code => ({ code, name: countryName(code, locale) })).sort((a, b) => a.name.localeCompare(b.name, locale));
}
